const dataConfig = {
    // Trucks to hide Past Catering
    hidePastHoodContactFrom: [
        1,
        39
    ],
    // endregion

    // region Override Vendor Account to Sign Up
    overrideVendorEmails: [
        'info@wildwesttexmex.com',
        'kona@konaskorner.com',
        'info@macnchoose.com',
        's.rosa@sks-services.com',
        'eattacos@vatoslocos-tacos.com',
        'concierge@lawsonadventurepark.com'
    ],
    // endregion

    // region Test Accounts
    testAccounts: [
        'mollyhollowell@gmail.com',
        'chollowell18@gmail.com'
    ],
    // endregion

    // region Cuisines
    cuisines: [
        {
            'id': 9,
            'name': 'Multi-Cuisine',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/multi-cuisine.jpeg',
            'slug': 'multi-cuisine'
        },
        {
            'id': 33,
            'name': 'American',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/american.jpg',
            'slug': 'american'
        },
        {
            'id': 14,
            'name': 'Asian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/asian.jpg',
            'slug': 'asian'
        },
        {
            'id': 2,
            'name': 'BBQ',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/bbq.jpg',
            'slug': 'bbq'
        },
        {
            'id': 47,
            'name': 'Brazilian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/brazilian.jpg',
            'slug': 'brazilian'
        },
        {
            'id': 53,
            'name': 'Breakfast',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/breakfast.jpg',
            'slug': 'breakfast'
        },
        {
            'id': 23,
            'name': 'Burgers',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/burgers.jpg',
            'slug': 'burgers'
        },
        {
            'id': 56,
            'name': 'Cajun',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/cajun-creole.jpg',
            'slug': 'cajun'
        },
        {
            'id': 40,
            'name': 'Caribbean',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/carribian.jpeg',
            'slug': 'caribbean'
        },
        {
            'id': 7,
            'name': 'Chicago Style',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/chicago.jpg',
            'slug': 'chicago-style'
        },
        {
            'id': 55,
            'name': 'Chinese',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/chinese.jpg',
            'slug': 'chinese'
        },
        {
            'id': 13,
            'name': 'Coffee',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/coffee.jpg',
            'slug': 'coffee'
        },
        {
            'id': 28,
            'name': 'Colombian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/columbian.jpg',
            'slug': 'colombian'
        },
        {
            'id': 12,
            'name': 'Crepes',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/crepes.jpg',
            'slug': 'crepes'
        },
        {
            'id': 20,
            'name': 'Cuban',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/cuban.jpg',
            'slug': 'cuban'
        },
        {
            'id': 50,
            'name': 'Dessert',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/dessert.jpg',
            'slug': 'dessert'
        },
        {
            'id': 46,
            'name': 'Ethiopian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/ethiopian.jpg',
            'slug': 'ethiopian'
        },
        {
            'id': 32,
            'name': 'Farm Fresh',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/farm-fresh.jpg',
            'slug': 'farm-fresh'
        },
        {
            'id': 17,
            'name': 'Filipino',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/filipino.jpg',
            'slug': 'filipino'
        },
        {
            'id': 11,
            'name': 'French',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/french.jpg',
            'slug': 'french'
        },
        {
            'id': 48,
            'name': 'German',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/german.jpg',
            'slug': 'german'
        },
        {
            'id': 18,
            'name': 'Greek',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/greek.jpg',
            'slug': 'greek'
        },
        {
            'id': 27,
            'name': 'Hawaiian style',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/hawaiian.jpg',
            'slug': 'hawaiian-style'
        },
        {
            'id': 10,
            'name': 'Indian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/indian.jpg',
            'slug': 'indian'
        },
        {
            'id': 26,
            'name': 'Italian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/italian.jpg',
            'slug': 'italian'
        },
        {
            'id': 35,
            'name': 'Jamaican',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/jamaican.jpg',
            'slug': 'jamaican'
        },
        {
            'id': 36,
            'name': 'Japanese',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/japanese.jpg',
            'slug': 'japanese'
        },
        {
            'id': 21,
            'name': 'Juice',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/juice.jpg',
            'slug': 'juice'
        },
        {
            'id': 6,
            'name': 'Latin American',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/latin-american.jpg',
            'slug': 'latin-american'
        },
        {
            'id': 4,
            'name': 'Latin Asian Fusion',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/latin-asian-fusion.jpg',
            'slug': 'latin-asian-fusion'
        },
        {
            'id': 1,
            'name': 'Mediterranean',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/mediterranean.jpg',
            'slug': 'mediterranean'
        },
        {
            'id': 24,
            'name': 'Mexican',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/mexican.jpg',
            'slug': 'mexican'
        },
        {
            'id': 22,
            'name': 'Middle Eastern',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/middle-eastern.jpg',
            'slug': 'middle-eastern'
        },
        {
            'id': 43,
            'name': 'Native American',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/native-american.jpg',
            'slug': 'native-american'
        },
        {
            'id': 31,
            'name': 'New England',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/new-england.jpg',
            'slug': 'new-england'
        },
        {
            'id': 3,
            'name': 'Peruvian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/peruvian.jpg',
            'slug': 'peruvian'
        },
        {
            'id': 15,
            'name': 'Pizza ',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/pizza.jpg',
            'slug': 'pizza'
        },
        {
            'id': 16,
            'name': 'Polish',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/polish.jpg',
            'slug': 'polish'
        },
        {
            'id': 29,
            'name': 'Polynesian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/polynesian.jpg',
            'slug': 'polynesian'
        },
        {
            'id': 5,
            'name': 'Puertorican',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/puertorican.jpg',
            'slug': 'puertorican'
        },
        {
            'id': 30,
            'name': 'Senegalese',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/senegalese.jpg',
            'slug': 'senegalese'
        },
        {
            'id': 39,
            'name': 'Southern',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/southern.jpg',
            'slug': 'southern'
        },
        {
            'id': 49,
            'name': 'Spanish',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/spanish.jpg',
            'slug': 'spanish'
        },
        {
            'id': 8,
            'name': 'Thai',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/thai.jpg',
            'slug': 'thai'
        },
        {
            'id': 44,
            'name': 'Turkish',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/turkish.jpg',
            'slug': 'turkish'
        },
        {
            'id': 41,
            'name': 'Vegan',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/vegan.jpg',
            'slug': 'vegan'
        },
        {
            'id': 51,
            'name': 'Vegetarian',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/vegetarian.jpg',
            'slug': 'vegetarian'
        },
        {
            'id': 25,
            'name': 'Venezuelan',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/venezuelan.jpg',
            'slug': 'venezuelan'
        },
        {
            'id': 37,
            'name': 'Wings',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/wings.jpg',
            'slug': 'wings'
        },
        {
            'id': 57,
            'name': 'Zimbabwean ',
            'image_url': 'https://dev.gotruckster.com/storage/cuisine/zimbabwean.jpg',
            'slug': 'zimbabwean'
        }
    ],
    // endregion

    // region Cities
    cities: {
        '18316': {
            'id': 18316,
            'name': 'Fort Collins',
            'image': require('../images/cities/city_fort_collins.jpg'),
            'slug': 'fort-collins',
            'state': {
                'id': 24,
                'name': 'Colorado',
                'short_name': 'CO'
            },
            'coordinates': {
                'latitude': 40.5958673,
                'longitude': -105.1430629
            },
            'isActive': true
        },
        '26476': {
            'id': 26476,
            'name': 'Boise',
            'image': require('../images/cities/city_boise.jpg'),
            'slug': 'boise',
            'total_truck': 0,
            'state': {
                'id': 36,
                'name': 'Idaho',
                'short_name': 'ID'
            },
            'coordinates': {
                'latitude': 43.618230,
                'longitude': -116.199409,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            }
        },
        '18338': {
            'id': 18338,
            'name': 'Boulder',
            'image': require('../images/cities/city_boulder.jpg'),
            'slug': 'boulder',
            'state': {
                'id': 24,
                'name': 'Colorado',
                'short_name': 'CO'
            },
            'coordinates': {
                'latitude': 40.0155889,
                'longitude': -105.2807213
            },
            'isActive': true
        },
        '18040': {
            'id': 18040,
            'name': 'Colorado Springs',
            'image': require('../images/cities/city_colorado_spring.jpg'),
            'slug': 'colorado-springs',
            'description': 'Colorado Springs Food Truck Events & Festivals\n        Truckster is your gateway into the food truck community and lets you know about the best local food truck festivals and events happening throughout Colorado. Whether you are looking for a family friendly event, a unique brewery event, or a music festival, we’ve got you covered. Here are a few of our favorite regularly occurring events to keep you happy all year long. Be sure to go to the <a target="_blank" rel="nofollow" href="https://apps.apple.com/us/app/truckster-denver-food-trucks/id1375284993?ls=1">App Store</a> or <a target="_blank" rel="nofollow" href="https://play.google.com/store/apps/details?id=com.truckster">Google Play</a> to download Truckster and find all the food truck events happening near you.',
            'state': {
                'id': 24,
                'name': 'Colorado',
                'short_name': 'CO'
            },
            'coordinates': {
                'latitude': 38.8378506,
                'longitude': -104.8246507
            },
            'isActive': true
        },
        '7855': {
            'id': 7855,
            'name': 'Dallas',
            'image': require('../images/cities/city_dallas.jpeg'),
            'slug': 'dallas',
            'state': {
                'id': 13,
                'name': 'Texas',
                'short_name': 'TX'
            },
            'coordinates': {
                'latitude': 32.7811829,
                'longitude': -96.7970282,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            }
        },
        '17828': {
            'id': 17828,
            'name': 'Denver',
            'image': require('../images/cities/city_denver.jpg'),
            'slug': 'denver',
            'state': {
                'id': 24,
                'name': 'Colorado',
                'short_name': 'CO'
            },
            'coordinates': {
                'latitude': 39.7645183,
                'longitude': -104.9955371
            },
            'isActive': true
        },
        '8024': {
            'id': 8024,
            'name': 'Austin',
            'image': require('../images/cities/city_austin.jpg'),
            'slug': 'austin',
            'state': {
                'id': 13,
                'name': 'Texas',
                'short_name': 'TX'
            },
            'coordinates': {
                'latitude': 30.2607452,
                'longitude': -97.7553748
            },
            'isActive': false
        },
        '37206': {
            'id': 37206,
            'name': 'Portland',
            'image': require('../images/cities/city_portland.jpg'),
            'slug': 'portland',
            'state': {
                'id': 52,
                'name': 'Oregon',
                'short_name': 'OR'
            },
            'coordinates': {
                'latitude': 45.5162267,
                'longitude': -122.6857396
            },
            'isActive': false
        },
        '27149': {
            'id': 27149,
            'name': 'Portland',
            'image': require('../images/cities/city_portland_maine.png'),
            'slug': 'portland',
            'state': {
                'id': 38,
                'name': 'Maine',
                'short_name': 'ME'
            },
            'coordinates': {
                'latitude': 43.646486,
                'longitude': -70.309569,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            }
        },
        '30846': {
            'id': 30846,
            'name': 'Kansas City',
            'image': require('../images/cities/city_kansas.jpeg'),
            'slug': 'kansas-city',
            'total_truck': 1,
            'state': {
                'id': 43,
                'name': 'Missouri',
                'short_name': 'MO'
            },
            'coordinates': {
                'latitude': 45.5162267,
                'longitude': -122.6857396,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            },
            'isActive': true
        },
        '33921': {
            'id': 33921,
            'name': 'Kansas City',
            'image': require('../images/cities/city_kansas_ks.jpeg'),
            'slug': 'kansas-city',
            'total_truck': 0,
            'state': {
                'id': 47,
                'name': 'Kansas',
                'short_name': 'KS'
            },
            'coordinates': {
                'latitude': 45.5162267,
                'longitude': -122.6857396,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            },
            'isActive': true
        },
        '8552': {
            'id': 8552,
            'name': 'Houston',
            'image': require('../images/cities/city_houston.jpeg'),
            'state': {
                'id': 13,
                'name': 'Texas',
                'short_name': 'TX'
            },
            'coordinates': {
                'latitude': 29.7641492,
                'longitude': -95.3703117,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            },
            'isActive': true
        },
        '3692': {
            'id': 3692,
            'name': 'Miami',
            'image': require('../images/cities/city_miami.jpeg'),
            'state': {
                'id': 8,
                'name': 'Florida',
                'short_name': 'FL'
            },
            'coordinates': {
                'latitude': 25.7784184,
                'longitude': -80.2197949,
                'latitudeDelta': 0.008,
                'longitudeDelta': 0.007
            },
            'isActive': true
        },
        '33139': {
            'id': 33139,
            'name': 'Detroit',
            'image': 'https://images.gotruckster.com/city/Detroit/Detroit-Michigan-Skyline.jpg',
            'state': {
                'id': 45,
                'name': 'Michigan',
                'short_name': 'MI'
            },
            'isActive': true
        },
        '11901': {
            'id': 11901,
            'name': 'Nashville',
            'image': 'https://images.gotruckster.com/city/Nashville/Nashville-Tennessee-Skyline.jpeg',
            'state': {
                'id': 18,
                'name': 'Tennessee',
                'short_name': 'TN'
            },
            'isActive': true
        },
        '26422': {
            'id': 26422,
            'name': 'Phoenix',
            'image': 'https://images.gotruckster.com/city/Phoenix/Phoenix-Arizona-Skyline.jpeg',
            'state': {
                'id': 35,
                'name': 'Arizona',
                'short_name': 'AZ'
            }
        },
        '6406': {
            'id': 6406,
            'name': 'Fort Worth',
            'image': require('../images/cities/city_fort_worth.jpeg'),
            'state': {
                'id': 13,
                'name': 'Texas',
                'short_name': 'TX'
            }
        },
        '4139': {
            'id': 4139,
            'name': 'Tampa',
            'image': 'https://images.gotruckster.com/city/Tampa/Tampa-Bay-Skyline.jpg',
            'state': {
                'id': 8,
                'name': 'Florida',
                'short_name': 'FL'
            }
        },
        '16721': {
            'id': 16721,
            'name': 'San Diego',
            'image': require('../images/cities/city_san_diego.jpeg'),
            'state': {
                'id': 21,
                'name': 'California',
                'short_name': 'CA'
            },
            'isActive': true
        }
    },
    // endregion

    // region Timezone Data
    timezoneData: [
        'Africa/Abidjan|Africa/Bamako',
        'Africa/Abidjan|Africa/Banjul',
        'Africa/Abidjan|Africa/Conakry',
        'Africa/Abidjan|Africa/Dakar',
        'Africa/Abidjan|Africa/Freetown',
        'Africa/Abidjan|Africa/Lome',
        'Africa/Abidjan|Africa/Nouakchott',
        'Africa/Abidjan|Africa/Ouagadougou',
        'Africa/Abidjan|Africa/Timbuktu',
        'Africa/Abidjan|Atlantic/St_Helena',
        'Africa/Cairo|Egypt',
        'Africa/Johannesburg|Africa/Maseru',
        'Africa/Johannesburg|Africa/Mbabane',
        'Africa/Lagos|Africa/Bangui',
        'Africa/Lagos|Africa/Brazzaville',
        'Africa/Lagos|Africa/Douala',
        'Africa/Lagos|Africa/Kinshasa',
        'Africa/Lagos|Africa/Libreville',
        'Africa/Lagos|Africa/Luanda',
        'Africa/Lagos|Africa/Malabo',
        'Africa/Lagos|Africa/Niamey',
        'Africa/Lagos|Africa/Porto-Novo',
        'Africa/Maputo|Africa/Blantyre',
        'Africa/Maputo|Africa/Bujumbura',
        'Africa/Maputo|Africa/Gaborone',
        'Africa/Maputo|Africa/Harare',
        'Africa/Maputo|Africa/Kigali',
        'Africa/Maputo|Africa/Lubumbashi',
        'Africa/Maputo|Africa/Lusaka',
        'Africa/Nairobi|Africa/Addis_Ababa',
        'Africa/Nairobi|Africa/Asmara',
        'Africa/Nairobi|Africa/Asmera',
        'Africa/Nairobi|Africa/Dar_es_Salaam',
        'Africa/Nairobi|Africa/Djibouti',
        'Africa/Nairobi|Africa/Kampala',
        'Africa/Nairobi|Africa/Mogadishu',
        'Africa/Nairobi|Indian/Antananarivo',
        'Africa/Nairobi|Indian/Comoro',
        'Africa/Nairobi|Indian/Mayotte',
        'Africa/Tripoli|Libya',
        'America/Adak|America/Atka',
        'America/Adak|US/Aleutian',
        'America/Anchorage|US/Alaska',
        'America/Argentina/Buenos_Aires|America/Buenos_Aires',
        'America/Argentina/Catamarca|America/Argentina/ComodRivadavia',
        'America/Argentina/Catamarca|America/Catamarca',
        'America/Argentina/Cordoba|America/Cordoba',
        'America/Argentina/Cordoba|America/Rosario',
        'America/Argentina/Jujuy|America/Jujuy',
        'America/Argentina/Mendoza|America/Mendoza',
        'America/Atikokan|America/Coral_Harbour',
        'America/Chicago|US/Central',
        'America/Curacao|America/Aruba',
        'America/Curacao|America/Kralendijk',
        'America/Curacao|America/Lower_Princes',
        'America/Denver|America/Shiprock',
        'America/Denver|Navajo',
        'America/Denver|US/Mountain',
        'America/Detroit|US/Michigan',
        'America/Edmonton|Canada/Mountain',
        'America/Fort_Wayne|America/Indiana/Indianapolis',
        'America/Fort_Wayne|America/Indianapolis',
        'America/Fort_Wayne|US/East-Indiana',
        'America/Halifax|Canada/Atlantic',
        'America/Havana|Cuba',
        'America/Indiana/Knox|America/Knox_IN',
        'America/Indiana/Knox|US/Indiana-Starke',
        'America/Jamaica|Jamaica',
        'America/Kentucky/Louisville|America/Louisville',
        'America/Los_Angeles|US/Pacific',
        'America/Los_Angeles|US/Pacific-New',
        'America/Manaus|Brazil/West',
        'America/Mazatlan|Mexico/BajaSur',
        'America/Mexico_City|Mexico/General',
        'America/New_York|US/Eastern',
        'America/Noronha|Brazil/DeNoronha',
        'America/Panama|America/Cayman',
        'America/Phoenix|US/Arizona',
        'America/Port_of_Spain|America/Anguilla',
        'America/Port_of_Spain|America/Antigua',
        'America/Port_of_Spain|America/Dominica',
        'America/Port_of_Spain|America/Grenada',
        'America/Port_of_Spain|America/Guadeloupe',
        'America/Port_of_Spain|America/Marigot',
        'America/Port_of_Spain|America/Montserrat',
        'America/Port_of_Spain|America/St_Barthelemy',
        'America/Port_of_Spain|America/St_Kitts',
        'America/Port_of_Spain|America/St_Lucia',
        'America/Port_of_Spain|America/St_Thomas',
        'America/Port_of_Spain|America/St_Vincent',
        'America/Port_of_Spain|America/Tortola',
        'America/Port_of_Spain|America/Virgin',
        'America/Regina|Canada/Saskatchewan',
        'America/Rio_Branco|America/Porto_Acre',
        'America/Rio_Branco|Brazil/Acre',
        'America/Santiago|Chile/Continental',
        'America/Sao_Paulo|Brazil/East',
        'America/St_Johns|Canada/Newfoundland',
        'America/Tijuana|America/Ensenada',
        'America/Tijuana|America/Santa_Isabel',
        'America/Tijuana|Mexico/BajaNorte',
        'America/Toronto|America/Montreal',
        'America/Toronto|Canada/Eastern',
        'America/Vancouver|Canada/Pacific',
        'America/Whitehorse|Canada/Yukon',
        'America/Winnipeg|Canada/Central',
        'Asia/Ashgabat|Asia/Ashkhabad',
        'Asia/Bangkok|Asia/Phnom_Penh',
        'Asia/Bangkok|Asia/Vientiane',
        'Asia/Dhaka|Asia/Dacca',
        'Asia/Dubai|Asia/Muscat',
        'Asia/Ho_Chi_Minh|Asia/Saigon',
        'Asia/Hong_Kong|Hongkong',
        'Asia/Jerusalem|Asia/Tel_Aviv',
        'Asia/Jerusalem|Israel',
        'Asia/Kathmandu|Asia/Katmandu',
        'Asia/Kolkata|Asia/Calcutta',
        'Asia/Macau|Asia/Macao',
        'Asia/Makassar|Asia/Ujung_Pandang',
        'Asia/Nicosia|Europe/Nicosia',
        'Asia/Qatar|Asia/Bahrain',
        'Asia/Rangoon|Asia/Yangon',
        'Asia/Riyadh|Asia/Aden',
        'Asia/Riyadh|Asia/Kuwait',
        'Asia/Seoul|ROK',
        'Asia/Shanghai|Asia/Chongqing',
        'Asia/Shanghai|Asia/Chungking',
        'Asia/Shanghai|Asia/Harbin',
        'Asia/Shanghai|PRC',
        'Asia/Singapore|Singapore',
        'Asia/Taipei|ROC',
        'Asia/Tehran|Iran',
        'Asia/Thimphu|Asia/Thimbu',
        'Asia/Tokyo|Japan',
        'Asia/Ulaanbaatar|Asia/Ulan_Bator',
        'Asia/Urumqi|Asia/Kashgar',
        'Atlantic/Faroe|Atlantic/Faeroe',
        'Atlantic/Reykjavik|Iceland',
        'Australia/Adelaide|Australia/South',
        'Australia/Brisbane|Australia/Queensland',
        'Australia/Broken_Hill|Australia/Yancowinna',
        'Australia/Darwin|Australia/North',
        'Australia/Hobart|Australia/Tasmania',
        'Australia/Lord_Howe|Australia/LHI',
        'Australia/Melbourne|Australia/Victoria',
        'Australia/Perth|Australia/West',
        'Australia/Sydney|Australia/ACT',
        'Australia/Sydney|Australia/Canberra',
        'Australia/Sydney|Australia/NSW',
        'Etc/GMT-0|Etc/GMT',
        'Etc/GMT-0|Etc/GMT+0',
        'Etc/GMT-0|Etc/GMT0',
        'Etc/GMT-0|Etc/Greenwich',
        'Etc/GMT-0|GMT',
        'Etc/GMT-0|GMT+0',
        'Etc/GMT-0|GMT-0',
        'Etc/GMT-0|GMT0',
        'Etc/GMT-0|Greenwich',
        'Etc/UTC|Etc/UCT',
        'Etc/UTC|Etc/Universal',
        'Etc/UTC|Etc/Zulu',
        'Etc/UTC|UCT',
        'Etc/UTC|UTC',
        'Etc/UTC|Universal',
        'Etc/UTC|Zulu',
        'Europe/Belgrade|Europe/Ljubljana',
        'Europe/Belgrade|Europe/Podgorica',
        'Europe/Belgrade|Europe/Sarajevo',
        'Europe/Belgrade|Europe/Skopje',
        'Europe/Belgrade|Europe/Zagreb',
        'Europe/Chisinau|Europe/Tiraspol',
        'Europe/Dublin|Eire',
        'Europe/Helsinki|Europe/Mariehamn',
        'Europe/Istanbul|Asia/Istanbul',
        'Europe/Istanbul|Turkey',
        'Europe/Lisbon|Portugal',
        'Europe/London|Europe/Belfast',
        'Europe/London|Europe/Guernsey',
        'Europe/London|Europe/Isle_of_Man',
        'Europe/London|Europe/Jersey',
        'Europe/London|GB',
        'Europe/London|GB-Eire',
        'Europe/Moscow|W-SU',
        'Europe/Oslo|Arctic/Longyearbyen',
        'Europe/Oslo|Atlantic/Jan_Mayen',
        'Europe/Prague|Europe/Bratislava',
        'Europe/Rome|Europe/San_Marino',
        'Europe/Rome|Europe/Vatican',
        'Europe/Warsaw|Poland',
        'Europe/Zurich|Europe/Busingen',
        'Europe/Zurich|Europe/Vaduz',
        'Pacific/Auckland|Antarctica/McMurdo',
        'Pacific/Auckland|Antarctica/South_Pole',
        'Pacific/Auckland|NZ',
        'Pacific/Chatham|NZ-CHAT',
        'Pacific/Chuuk|Pacific/Truk',
        'Pacific/Chuuk|Pacific/Yap',
        'Pacific/Easter|Chile/EasterIsland',
        'Pacific/Guam|Pacific/Saipan',
        'Pacific/Honolulu|Pacific/Johnston',
        'Pacific/Honolulu|US/Hawaii',
        'Pacific/Kwajalein|Kwajalein',
        'Pacific/Pago_Pago|Pacific/Midway',
        'Pacific/Pago_Pago|Pacific/Samoa',
        'Pacific/Pago_Pago|US/Samoa',
        'Pacific/Pohnpei|Pacific/Ponape'
    ],
    replaceTimezone: {
        'UTC-7: Mountain Standard Time (MST)': 'US/Mountain'
    },
    // endregion

    // region Square Permissions
    squarePermission: [
        'MERCHANT_PROFILE_READ',
        'PAYMENTS_READ',
        'PAYMENTS_WRITE',
        'PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS',
        'CUSTOMERS_READ',
        'CUSTOMERS_WRITE',
        'ITEMS_READ',
        'ITEMS_WRITE',
        'ORDERS_READ',
        'ORDERS_WRITE'
    ],
    // endregion

    // region Help Center
    helpCenter: [
        {
            question: 'How do I add my schedule to Truckster?',
            answer:
                'In an effort to accommodate all situations, we have three options for you here. Go to the Truck Profile and then the Schedule tab to get started.\n\n' +
                'Option 1: Build events directly into Truckster Vendor. Click on the date you are serving, and click New Event. Add your relevant info (especially the address!) and hit save. You can make events recurring. For example if you go to a brewery every Thursday, you can build it on one Thursday, click repeat, and hit Every week.\n\n' +
                'Option 2: Link up your Google Calendar and choose which events you want to import. Have some personal stuff you don’t want everyone to see? Maybe some private catering that you don’t want listed publicly? Link up your Google Calendar, set your date range, and hit import. The calendar events will show up on the right. Click on them and choose which ones you want to import onto Truckster Vendor.\n\n' +
                'Option 3: Auto Sync your Google Calendar. Link up your Google Calendar, and then click Auto Sync. Click the refresh button to see all the events populated on your calendar. This is a great option if you keep your Google Calendar updated with accurate information and addresses. Whenever you make a change to your calendar, it will automatically reflect on Truckster Vendor after the next refresh.'
        },
        {
            question: 'What do I do if I sell out of a menu item?',
            answer: 'Easy, just make it inactive on the Menu tab. This way you don’t have to delete the item and type it back in once you’re restocked.'
        },
        {
            question: 'How do I setup mobile ordering?',
            answer:
                'You need to have a Square account. If you use a different POS on your truck, Square is free to setup, and they will only charge you processing fees on the Truckster mobile orders. So you can have the best of both worlds! To setup mobile ordering, you simply need to sign into your Square account on the Orders tab, then you’re set!\n\n' +
                'Mobile ordering is ONLY AVAILABLE when you have an event. When you have a calendar event on Truckster, then people can mobile order.\n\n' +
                'Don’t want to offer ordering today? No worries, simply turn it off on the Orders tab. Just remember to turn it back on before your next shift!'
        },
        {
            question: 'What if I have a question for a customer on their mobile order?',
            answer: 'You can text them, but they can’t text you back. If you have any questions for them,give them your number in the text so they can respond. This is for the customer’s safety and privacy. '
        },
        {
            question: 'I have multiple trucks. How do I accept mobile orders?',
            answer:
                'You need to have multiple Square Locations. As long as you have a Square Location that you can assign to each truck, you’re all set. When events are imported into Truckster, they will automatically be assigned to your first Square Location. Go into the events for your second truck and assign the Square Location to match the one for your second truck. Then, make sure each truck’s Truckster Vendor account is set to the right Square Location.\n\n' +
                'Now when a consumer orders, it will ask them for which event location they want to order. As long as you stay organized with assigning the Square Locations and keeping the trucks signed into the right Location, it should be easy peasy.'
        },
        {
            question: 'Okay I accepted a catering lead, now what?',
            answer:
                'There are two types of leads – ones where you were requested specifically and ones where the consumer was looking for options. If you were specifically requested, then check your email for an introduction to the client. Confirm the details directly with the client and you should be all set.\n\n' +
                'If the client wanted options, you will see in your confirmation notification and the introduction email that you are one of three trucks available. So sell yourself! Send over a menu, quote, show your charm, you know what to do.\n\n' +
                'Please keep us posted on which events are confirmed. If a client is being difficult, let us know and we can step back in to help.'
        },
        {
            question: 'The client’s budget is $1, what does that mean?',
            answer:
                'One of two things – either attendees are paying so they don’t have a budget, or they aren’t sure what to budget. When you’re introduced to them, ask about their specific situation. Maybe they need a quote from you, or they can tell you how many attendees there will be and what % they expect will eat.\n\n' +
                'What’s the difference between my overview contact information and my account contact information?\n\n' +
                'The email and phone number listed on the Food Trucks, Overview tab is what shows up on your public profile for the consumer app and website. You can edit this on the Information tab.\n\n' +
                'However Truckster Vendor notifications, like catering leads, are sent to your account contact information. You can edit this under Account Settings.'
        },
        {
            question: 'On the dashboard, what are the catering request $? I’ve had more (or less) in catering from Truckster?',
            answer: 'These represent the budget submitted by the customer when they requested your specific truck. Most of our catering requests are for a cuisine type, and then we send them to the trucks that would be best fits for that event. These leads we’ve sent you are not reflected here. On the other hand, someone might have requested you, but you declined the lead. Again, this just signifies the budget $ when your truck was requested.'
        }
    ],
    // endregion

    // region Start Printer Models
    startPrinterEmulation: {
        'mPOP': 'StarPRNT',
        'FVP10': 'StarLine',
        'TSP100': 'StarGraphic',
        'TSP650II': 'StarLine',
        'TSP700II': 'StarLine',
        'TSP800II': 'StarLine',
        'SP700': 'StarDotImpact',
        'SM-S210i': 'EscPosMobile',
        'SM-S220i': 'EscPosMobile',
        'SM-S230i': 'EscPosMobile',
        'SM-T300i/T300': 'EscPosMobile',
        'SM-T400i': 'EscPosMobile',
        'SM-L200': 'StarPRNT',
        'SM-L300': 'StarPRNT',
        'BSC10': 'EscPos',
        'SM-S210i StarPRNT': 'StarPRNT',
        'SM-S220i StarPRNT': 'StarPRNT',
        'SM-S230i StarPRNT': 'StarPRNT',
        'SM-T300i/T300 StarPRNT': 'StarPRNT',
        'SM-T400i StarPRNT': 'StarPRNT'
    },
    // endregion

    // region Service Agreement
    serviceAgreement:
        'This Truckster Service Agreement (“Agreement”), is entered into by and between Hollowell Partners, LLC, dba “Truckster” a Colorado Limited Liability Company (“Truckster”) and [INSERT NAME OF FOOD TRUCK] (“Customer”).' +
        '\n\nTruckster is in the business of creating and maintaining a network of food trucks to create promotional value to owners and accessibility to their end-consumers; and Customer would like to utilize Truckster’s services (as set forth herein), subject to the terms and conditions set forth in this Agreement.' +
        '\n\nIn consideration of the premises, and respective representations, warranties, covenants and agreements of Truckster and Customer set forth in this Agreement, Truckster and Customer agree as follows:' +
        '\n\n1. Scope of services: The services provided in the subscription include access to certain services or features on Truckster Vendor and promotion through Truckster’s consumer facing app and website depending on the tier described below ("Subscription Services"). Other services could be added and agreed to via email, phone, or other verbal communication.' +
        '\na. Tier 0: Access to basic profile information on Truckster Vendor.' +
        '\nb. Tier 1: Access to the Profile on Truckster Vendor, calendar integration, responding to reviews, limited dashboard analytics, and catering requests specific to the Customer’s business.' +
        '\nc. Tier 2: Access to all of Tier 1 services and features, as well as social media promotion, additional catering requests, limited access to Truckster Hoods, additional dashboard analytics, and Truckster Vendor Chat.' +
        '\nd. Tier 3: Access to all of Tier 1 and Tier 2 services and features, as well as a rotating spot on the Featured trucks, full access to Truckster Hoods, and Truckster Ordering.' +
        '\n\n2. Subscription pricing: For Subscription Services, Truckster will charge a monthly subscription which varies depending on the Truck Classification and the Subscription Tier (“Subscription”). Customer is entitled to a 30 day free trial, plus other promotions as offered. If the Agreement does not begin on the first day of the month, the Subscription shall be prorated accordingly. Price and special promotion changes thereafter may be communicated and agreed to via email, phone or other verbal communication. All sales are final and are NOT subject to refunds.' +
        '\na. Tier 0: Free.' +
        '\nb. Tier 1: $20/month. ' +
        '\nc. Tier 2: $20/month for Standard cities and $35/month for Premium Lead Generation cities.' +
        '\nd. Tier 3: $20/month for Standard cities and $45/month for Premium Lead Generation cities.' +
        '\n(Special promotion: The Customer will receive their next month\'s subscription for free if they receive 50 orders in the given month).' +
        '\ne. Annual Payment: Customer may request to pay their subscription annually rather than monthly for a discount.' +
        '\n\nNote: Standard cities and Premium Lead Generation cities are determined by Customer’s serving cities and are subject to change over time.' +
        '\n\n3. Non-operating months: Customer has the ability to suspend the Subscription Services in non-operating months, for a maximum of 5 consecutive months. During non-operating months, Truckster will not charge the monthly subscription.' +
        '\n\n4. Catering Services: The scope of Truckster’s Catering Services includes sourcing leads, coordinating upfront logistics, introducing clients and food trucks, sending reminders, and collecting feedback. The Customer is responsible for finalizing pricing, collecting payment, and securing contracts with catering clients if desired. Related to Catering Services, Truckster also offers Truckster Hoods and Truckster Partnerships, which are relationships Truckster manages with clients who host food trucks from time to time. The Customer acknowledges that it is representing its own business as well as Truckster and will make best efforts to serve events with the utmost quality and service. Unless otherwise specified by the client, the Customer will provide its own trash cans.' +
        '\n\n5. Catering Pricing: For Catering Services (applying to Catering Services, Truckster Hoods, and Truckster Partners), Truckster will charge 10% of sales excluding taxes and tips, or other similar amount as agreed to by both parties on a case by case basis.' +
        '\n\n6. Sales Feedback: Sales feedback should be provided at the conclusion of the event, and no later than 72 hours after the conclusion of the event. Failure to provide feedback within 72 hours will result in a 5% increase to the catering pricing. If the Customer does not enter in sales feedback within 30 days, Truckster will charge it’s catering fee based on sales expectations for the event (plus the 5% increase). A photo proving the Customer’s sales is required. Screenshots of the Customer’s POS dashboard or client receipts are acceptable.' +
        '\n\n7. Payment Terms: Customer is required to provide a method of payment to Truckster in order to receive Catering Services and/or Subscription Services. Bank or credit card payment methods are acceptable. In the case that no payment method is on file or the payment method is declined, the invoices are due upon receipt. Invoices later than 30 days will bear interest of 10% per month and access to Truckster Vendor and catering leads will be temporarily revoked until delinquent invoices are paid. If Truckster tries to process any payment by credit card or ACH transfer that you have previously authorized and the charge is declined, Truckster will charge Customer for any fees incurred.' +
        '\n\n8. Ordering Convenience Fees: Truckster charges the end-consumer a transactional convenience fee on mobile orders. There is no charge to the Customer for access to Truckster’s Ordering Services.' +
        '\n\n9. Penalties: If Customer does not show up for a Truckster catering or other scheduled food truck booking, then Truckster has the right to charge the Customer a $50 no show fee (“No Show Fee”). If the Customer cancels a Truckster catering or other scheduled food truck booking within 48 hours of the event date, then Truckster has the right to charge the Customer a $25 cancellation fee (“Cancellation Fee”). These fees are necessary to recoup the business lost by Truckster, to compensate for the catering client’s dissatisfaction with Truckster, and the effort required to find replacements. ' +
        '\n\n10. Information Rights; Intellectual Property Rights: Truckster has the right to use information that is provided by the Customer or is otherwise publicly available on the Customer’s website, social media, or other public forum, including without limitation schedules, events, photos, contact information, and any other content of any sort, including trademarks, copyrighted material, and other matter subject to intellectual property protection (the “Information”). Truckster intends to use the Information to promote the Customer on the Truckster platform, social media, email communication, and other similar platforms. Customer hereby warrants that all of the Information is either (i) Customer-created, (ii) available in the public domain, or (iii) subject to a license that Customer can freely transfer to Truckster. Customer hereby grants to Truckster a paid-up, worldwide, and non-exclusive license to use or display the Information during the term of this Agreement. Truckster shall abide by Customer guidelines, if any, in displaying the Information. ' +
        '\n\n11. Sales Information: Truckster may, from time to time, share Customer’s sales information for specific events with the main point of contact for said events, for the purposes of improving and managing future events.' +
        '\n\n12. Sales Tax Responsibility: Customer is solely responsible for remitting sales tax on their event sales and ordering sales facilitated through Truckster.' +
        '\n\n13. Licensing: Customer is appropriately licensed to operate a food truck. The Customer will only accept Truckster Catering Services where the Customer has the necessary licensing required to serve. Truckster is not liable to verify the truck’s licensing.' +
        '\n\n14. Insurance; Subrogation: Customer shall maintain at all times appropriate levels of insurance to operate their business. In the event that Customer is hired for a catering event, Truckster Hood or Truckster Partner event in which Truckster is required to provide a Certificate of Insurance, then a Certificate of Insurance will be required from Customer for each of the following insurance policies:' +
        '\na. A general liability insurance policy with coverage values of at least one million dollars ($1,000,000) per instance and two million dollars ($2,000,000) in aggregate;' +
        '\nb. An auto insurance policy with a combined coverage limit of at least one million dollars ($1,000,000); and' +
        '\nc. Workers compensation insurance with an employer coverage limit of at least five hundred thousand dollars ($500,000) All general liability, auto insurance, and worker’s compensation policies of Customer shall collectively be referred to as the “Policies”. ' +
        '\nd. Customer shall further comply with all guidelines regarding insurance for any event in which Truckster arranges for Customer to participate, and which Truckster shall provide to Customer in advance of such event.' +
        '\ne. Upon request, Customer shall have Truckster named as an additional insured on each of the Policies, and shall provide copies of the Policies in such manner as Truckster directs.' +
        '\nf. Customer agrees that with respect to any losses whatsoever that may be covered by the Polices, Customer hereby waives and releases in favor of Truckster, and shall cause the insurer of the Policies to waive and release in favor of Truckster, any legal claims against Truckster for such losses.' +
        '\n\n15. Maintenance: Truckster may take its services offline from time to time for maintenance.' +
        '\n\n16. Term of Agreement: This Agreement is valid for 1 year, with perpetual automatic renewals for subsequent 1 year periods, unless the Agreement is terminated. Either party may terminate this Agreement for any reason by providing 30 days’ notice to the other party. Unused portions of Subscription payments are NOT refundable upon termination.' +
        '\n\n17. Representations: The parties have the authority and capacity to enter into and have duly executed and delivered this Agreement. This Agreement constitutes a legal, valid, and binding obligation, enforceable against the parties according to its terms.' +
        '\n\n18. Mutual Indemnification: Each party shall indemnify the other against all losses arising out of any proceeding brought by either a third party or an indemnified party, and arising out of the indemnifying party’s willful misconduct or gross negligence.' +
        '\n\n19. Force Majeure: Neither party will be liable for performance delays nor for non-performance due to causes beyond reasonable control, except for payment obligations.' +
        '\n\n20. Relationship: Nothing in this Agreement creates any special relationship between the parties, such as a partnership, joint venture, or employee/employer relationship between the parties.' +
        '\n\n21. General Provisions: The parties intend that this Agreement represents the final expression of the parties\' intent relating to the subject matter of this Agreement, and replace all of the parties\' previous discussions or understandings. Truckster may amend the terms and conditions of this Agreement at any time by reasonable notice. Neither party may assign this Agreement or any of their rights or obligations under this Agreement without the other party\'s written consent.' +
        '\n\n22. Governing Law: This Agreement shall be governed, construed, and enforced in accordance with the laws of the State of Colorado.' +
        '\n\n23. Severability: If any part of this Agreement is declared unenforceable or invalid, the remainder will continue to be valid and enforceable.',
    // endregion

    // region Badge Keys
    badgeKeys: {
        forum: 'moreBadgeCount',
        catering: 'cateringBadgeCount',
        order: 'orderingBadgeCount'
    }
    // endregion
};

export default dataConfig;
